import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { readPublicConfig } from "../config";

let client: SupabaseClient | undefined;
let publicClient: SupabaseClient | undefined;

/** Public registrations never read or persist an administrator's auth session. */
export function getPublicSupabaseClient(): SupabaseClient {
  if (publicClient) return publicClient;
  const config = readPublicConfig(import.meta.env);
  if (!config.supabaseUrl || !config.supabasePublishableKey)
    throw new Error("Public booking configuration is incomplete.");
  publicClient = createClient(config.supabaseUrl, config.supabasePublishableKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  });
  return publicClient;
}

export function getSupabaseClient(): SupabaseClient {
  if (client) {
    return client;
  }

  const config = readPublicConfig(import.meta.env);

  if (!config.supabaseUrl || !config.supabasePublishableKey) {
    throw new Error("Supabase browser configuration is incomplete.");
  }

  client = createClient(config.supabaseUrl, config.supabasePublishableKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });

  return client;
}
